// Copyright (c) 2016 Deere & Company

import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import {getDefaultState as getDateRangeDefaultState} from './date-range';
import t from 'tcomb';

const Criteria = t.struct({
    beginDate: DateRange,
    branch: t.String,
    dealers: t.list(Dealer, 'Dealers'),
    endDate: DateRange,
    factoryCode: t.String,
    pin: t.String,
    productRegistered: t.String,
    status: t.String
}, 'Criteria');

export const getDefaultState = () =>
    new Criteria({
        beginDate: getDateRangeDefaultState(),
        branch: '',
        dealers: [],
        endDate: getDateRangeDefaultState(),
        factoryCode: '',
        pin: '',
        productRegistered: '',
        status: ''
    });

export default Criteria;



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/state/criteria.js